package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.TabsDemo

@Page
@Composable
fun TabsPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/tabs.md", mapOf("title" to listOf("Tabs"), "description" to listOf("A set of layered sections of content—known as tab panels—that are displayed one at a time."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/tabs"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/tabs#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import shadcn.ui.components.*
import web.cssom.ClassName
import web.html.InputType

val TabsDemo = FC<Props> {
    Tabs {
        defaultValue="account"
        className = ClassName("w-[400px]")
        TabsList {
            className=ClassName("grid w-full grid-cols-2")
            TabsTrigger {
                value = "account"
                +"Account"
            }
            TabsTrigger {
                value = "password"
                +"Password"
            }
        }
        TabsContent {
            value = "account"
            Card {
                CardHeader {
                    CardTitle {
                        +"Account"
                    }
                    CardDescription {
                        +"Make changes to your account here. "
                        +"Click save when you're done."
                    }
                }
                CardContent {
                    className = ClassName("space-y-2")
                    div {
                        className = ClassName("space-y-1")
                        Label {
                            htmlFor ="name"
                            +"Name"
                        }
                        Input {
                            id="name"
                            defaultValue ="Pedro Duarte"
                        }
                    }
                    div {
                        className = ClassName("space-y-1")
                        Label {
                            htmlFor = "username"
                            +"Username"
                        }
                        Input {
                            id = "username"
                            defaultValue = "@peduarte"
                        }
                    }
                }
                CardFooter {
                    Button {
                        +"Save changes"
                    }
                }
            }
        }
        TabsContent {
            value = "password"
            Card {
                CardHeader {
                    CardTitle {
                        +"Password"
                    }
                    CardDescription {
                        +"Change your password here."
                        +"After saving, you'll be logged out."
                    }
                }
                CardContent {
                    className = ClassName("space-y-2")
                    div {
                        className = ClassName("space-y-1")
                        Label {
                            htmlFor ="current"
                            +"Current password"
                        }
                        Input {
                            id="current"
                            type = InputType.password
                        }
                    }
                    div {
                        className = ClassName("space-y-1")
                        Label {
                            htmlFor = "new"
                            +"New password"
                        }
                        Input {
                            id = "new"
                            type = InputType.password
                        }
                    }
                }
                CardFooter {
                    Button {
                        +"Save password"
                    }
                }
            }
        }
    }
}"""){ 
 TabsDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Tabs
import shadcn.ui.components.TabsContent
import shadcn.ui.components.TabsList
import shadcn.ui.components.TabsTrigger
""", lang= "kotlin", highlight= "")
            CodeBlock("""Tabs {
    defaultValue = "account"
    className = ClassName("w-[400px]")
    TabsList {
        TabsTrigger {
            value = "account"
            +"Account"
        }
        TabsTrigger {
            value = "password"
            +"Password"
        }
    }
    TabsContent {
        value = "account"
        +"Make changes to your account here."
    }
    TabsContent {
        value = "password"
        +"Change your password here."
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
